/**
 * Spanish Technology Translations
 * 技术页翻译模块 - 西班牙语
 * 
 * 包含红外技术原理、技术优势、科学原理等翻译
 */

import type { TechnologyTranslations } from '../../types';

export const esTechnology: TechnologyTranslations = {
  title: 'La Ciencia del Calor',
  subtitle: 'Descubre cómo la tecnología de infrarrojo lejano aporta una calefacción más eficiente y confortable a tu espacio.',
  section1: {
    title: 'Como la Luz del Sol, en Todo el Espacio',
    desc1: 'Los calefactores tradicionales calientan principalmente el aire. El aire caliente sube al techo, lo que genera temperaturas desiguales y levanta el polvo.',
    desc2: 'La calefacción por infrarrojo lejano funciona de forma distinta. Igual que el sol, emite ondas electromagnéticas que calientan directamente los objetos y las personas. Las paredes, los suelos y los muebles absorben ese calor y lo liberan poco a poco, manteniendo un confort térmico estable en todo el ambiente.',
    radiant: 'Transferencia de Calor Radiante',
  },
  section2: {
    title: 'Tecnología Central de Calefacción',
    intro: 'Nuestro elemento calefactor de diseño especial, junto con nuestro recubrimiento nanotecnológico patentado, ofrece un rendimiento térmico sobresaliente.',
    surface: 'Recubrimiento Nanotecnológico',
    surfaceDesc: 'El recubrimiento nanotecnológico patentado aumenta notablemente el área de radiación, con una emisividad de hasta el 86 %.',
    rapid: 'Calentamiento Rápido',
    rapidDesc: 'El aluminio de alta conductividad alcanza la temperatura óptima en solo 5 minutos.',
    durability: 'Vida Útil Ultralarga',
    durabilityDesc: 'Diseñado para más de 25 años de funcionamiento sin mantenimiento.',
    nanoTitle: 'Nanotecnología',
  },
  infraredIntroduction: {
    title: 'Tecnología Avanzada de Infrarrojo Lejano',
    desc: 'Aprovecha la luz invisible del espectro para lograr una eficiencia térmica superior. Nuestra tecnología optimiza la banda de infrarrojo lejano para maximizar la absorción de calor por parte del cuerpo.',
    optimalWavelength: 'Longitud de Onda Óptima',
    optimalWavelengthDesc: 'Ajustada a una frecuencia específica que entra en resonancia natural con las moléculas de agua del cuerpo, para asegurar la máxima absorción y retención del calor.',
    superiorEfficiency: 'Rendimiento Superior',
    superiorEfficiencyDesc: 'Supera al infrarrojo cercano y medio. El infrarrojo lejano ofrece calor suave y uniforme, sin sensación de calor agresivo ni sequedad ambiental.',
    radiantEnergy: 'Energía Radiante',
    radiantEnergyDesc: 'Libera calor radiante puro que llega directamente a objetos y personas, sin depender de la circulación del aire y evitando así el desperdicio energético.',
  },
  healthBenefits: {
    title: 'Más Allá de la Calefacción: Beneficios para la Salud',
    desc: 'El infrarrojo lejano no solo abriga; su longitud de onda única ayuda a crear un entorno más saludable y confortable, cuidando activamente tu bienestar.',
    card1: {
      title: '"Luz de la Vida"',
      desc: 'Al funcionar en la banda de 8 a 15 μm, este calor coincide de forma natural con la frecuencia de tu cuerpo. El resultado es una calidez suave, de absorción profunda y muy natural.',
    },
    card2: {
      title: 'Respiración Limpia',
      desc: 'A diferencia de los calefactores tradicionales por convección, no levanta polvo, no dispersa alérgenos ni reseca el aire, lo que protege la piel y la salud respiratoria.',
    },
    card3: {
      title: 'Calidez Profunda y Relajante',
      desc: 'Las ondas térmicas de penetración profunda ayudan a favorecer la microcirculación, relajar los músculos y aliviar la rigidez típica del invierno.',
    },
  },
};
